/* eslint-disable no-unused-vars */
export enum FileStateType {
  NEW = 'new',
  IN_PROGRESS = 'in_progress',
  DELAY = 'delay',
  SENT_TO_BRANCH = 'sent_to_branch',
  REFER_TO_BRANCH = 'refer_to_branch',
  REFER_FROM_BRANCH = 'refer_from_branch',
  REFER_FROM_PROFESSIONAL = 'refer_from_professional',
  REFER_FROM_CHECKING = 'refer_from_checking',
  CANCELED = 'canceled',
  EDIT_REQUIRED = 'edit_required',
  CLOSED = 'closed',
  ARCHIVED = 'archived',
}

export type BackendFileActionsConst =
  | 'edit_visit_time'
  | 'time_set'
  | 'reject_file'
  | 'accept_file';

export type FileTypeConst = 'property' | 'body' | 'initial';
export type VehicleTypesType = 'car' | 'motorcycle';
export type VehicleDesignType = 'country' | 'free_zone';

export type FaConst<CT = string, FT = string> = {
  const: CT;
  fa_const: FT;
};
export type FileType = FaConst<FileTypeConst>;

export type FileStatus = FaConst<FileStateType>;

export type FileAction = {
  has_actions: boolean;
  actions: BackendFileActionsConst;
};

export type VisitProvinceType = {
  id: number;
  name: string;
};

export type VisitCountyType = {
  id: string;
  name: string;
  province: string;
};

export type FileInsurance = FaConst;

export type VehiclePlateType = {
  vehicle_plate_design: FaConst<VehicleDesignType>;
  vehicle_plate_left?: string;
  vehicle_plate_right?: string;
  vehicle_plate_letter?: {
    id: number;
    letter: string;
  };
  vehicle_plate_iran?: string;
  vehicle_plate_top?: string;
  vehicle_plate_bottom?: string;
  vehicle_plate_sample?: {
    id: number;
    title: string;
  };
  vehicle_plate?: string;
  vehicle_plate_type: {
    id: number;
    name: string;
    type: string;
  };
};

export type VehiclePlateInformationType = {
  vehicle_type: FaConst<VehicleTypesType>;
  vehicle_model: string;
} & VehiclePlateType;

export type ParticipantConstType = 'culprit' | 'damaged';
export type ParticipantFaType = 'زیان‌دیده' | 'مقصر';
export type ParticipantType = {
  const: ParticipantConstType;
  fa_const: ParticipantFaType;
};
export type OwnerConstType = 'legal' | 'real';
export type OwnerFaType = 'حقیقی' | 'حقوقی';
export type OwnerType = {
  const: OwnerConstType;
  fa_const: OwnerFaType;
};
export type userTypeType = 'culprit' | 'damaged' | 'insurer';
export type imageTypeType = 'document' | 'vehicle' | 'other_damaged_document';
export type damaged_entity_type = 'VEHICLE' | 'OTHER';
export type owner_type = 'real' | 'legal';
